import React from "react";
import HeroImg from "../../assets/svg/hero.svg";
import { Link } from "react-scroll";
import { useTranslation, Trans } from "react-i18next"; // ✅ import i18n hook

const Hero = () => {
  const { t } = useTranslation();
  return (
    <div className="container mx-auto max-w-7xl px-4 sm:px-0">
      <div className="flex flex-col sm:flex-row mt-5 sm:mt-5 items-center">
        <div className="ml-2 w-full sm:w-2/5 pt-6 sm:pt-0">
          <h2 className="text-cyan-900 font-extrabold text-3xl sm:text-4xl">
            {/* The First AI-powered<br></br>Office Search Portal */}
            <Trans i18nKey="hero_heading" />
          </h2>
          <p className="mt-3">
            {/* Leveraging the power of AI to redefine your office search
            experience. Explore, Compare, and Secure. */}
            {t("hero_subtext")}
          </p>
          <Link
            to="how-it-works"
            smooth={true}
            duration={500}
            className="bg-red-600 p-4 rounded-[58px] font-semibold text-white mt-4 inline-block cursor-pointer"
          >
            {/* See how it works */}
            {t("see_how_it_works")}
            {/* <i className="fa-solid fa-chevron-right"></i> */}
          </Link>
        </div>
        <img src={HeroImg} alt="" className="w-4/5 sm:w-3/5 mt-6 sm:mt-0" />
      </div>
    </div>
  );
};

export default Hero;
